/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Role_AssignedInputs */

const en_admin_users_role_assigned = /** @type {(inputs: Admin_Users_Role_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role assigned`)
};

/**
* | output |
* | --- |
* | "Role assigned" |
*
* @param {Admin_Users_Role_AssignedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_role_assigned = /** @type {((inputs?: Admin_Users_Role_AssignedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Role_AssignedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_role_assigned(inputs)
});
export { admin_users_role_assigned as "admin.users.role_assigned" }